import { render, staticRenderFns } from "./AccountPayables.vue?vue&type=template&id=4d6c8e3a&scoped=true&"
import script from "./AccountPayables.vue?vue&type=script&lang=ts&"
export * from "./AccountPayables.vue?vue&type=script&lang=ts&"
import style0 from "./AccountPayables.vue?vue&type=style&index=0&id=4d6c8e3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6c8e3a",
  null
  
)

export default component.exports